import { HorizontalLine } from "../horizontal-line/horizontal-line";
import { useState } from "react";
import { Calendar } from "react-date-range";
import { AiTwotoneCalendar } from "react-icons/ai";
import { MdOutlineArrowDropDown } from "react-icons/md";
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css";
import { format, addDays } from "date-fns";
import "./contact.css";

export const ContactUs = () => {
  const [openCheckinDate, setCheckinOpenDate] = useState(false);
  const [openCheckoutDate, setCheckoutOpenDate] = useState(false);
  const [checkinDateState, setCheckinDateState] = useState("dd/mm/yy");
  const [checkoutDateState, setCheckoutDateState] = useState("dd/mm/yy");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [typeState, setTypeState] = useState("Select Room Type");

  function handleCheckinSelect(date) {
    setCheckinDateState(`${format(date, "dd/MM/yyyy")}`);
  }
  function handleCheckoutSelect(date) {
    setCheckoutDateState(`${format(date, "dd/MM/yyyy")}`);
  }

  function convertDateFormat(dateString) {
    // Split the date string into three parts.
    const [day, month, year] = dateString.split("/");

    // Rearrange the parts in the order of year, month, and day.
    const convertedDateString = `${year}-${month}-${day}`;

    // Return the converted date string.
    return convertedDateString;
  }

  function convertRoomTypeFormat(type) {
    const [first, second] = type.split(" ");

    const convertedType = `${first}+${second}`;

    console.log(convertedType);

    return convertedType;
  }

  const handleSubmit = (event) => {
    const url = `https://docs.google.com/forms/d/e/1FAIpQLSeODAN5kmIEDo-z5xZgfYnk_GD5nnGwqcauKe042J1jygasqg/viewform?usp=pp_url&entry.1256246462=${
      event.target.fullname.value
    }&entry.1980350274=${
      event.target.number.value
    }&entry.1534861217=${convertDateFormat(
      checkinDateState
    )}&entry.2080276382=${convertDateFormat(
      checkoutDateState
    )}&entry.361077647=${convertRoomTypeFormat(typeState)}&entry.1219068314=${
      event.target.roomnumber.value
    }&entry.1896320164=${event.target.email.value}&entry.93531445=${
      event.target.phone.value
    }&entry.624668585=${event.target.requirement.value}`;
    window.open(url, "_blank");
  };
  return (
    <div className="contact-wrapper mt-[80px]">
      <h3 className="text-center text-[28px] mb-[25px] font-[400] md:mt-[50px]">
        Contact Us
      </h3>
      <div className="my-[28px] z-[1]">
        <HorizontalLine width={50} />
      </div>
      <form
        className=" w-[calc(100%_-_10px)] md:w-[calc(100%_-_60px)] max-w-[730px] mx-auto bg-gray-100 p-[20px]"
        onSubmit={handleSubmit}
      >
        <div className="flex justify-center space-x-5">
          <div className="name-wrapper text-[15px] font-[400] basis-1/2 ">
            <label className="">
              Your name <span className="text-[#ff0000]">*</span>
            </label>
            <input
              className="w-[100%] text-gray-text border border-[#dedede] px-[12px] py-[16px] mb-[25px] mt-[10px]"
              id="fullname"
              name="fullname"
            ></input>
          </div>
          <div className="name-wrapper text-[15px] font-[400] basis-1/2">
            <label className="">
              No. of Guests <span className="text-[#ff0000]">*</span>
            </label>
            <input
              className="w-[100%] text-gray-text border border-[#dedede] px-[12px] py-[16px] mb-[25px] mt-[10px]"
              id="number"
              name="number"
              type="number"
            ></input>
          </div>
        </div>
        <div className="flex justify-center space-x-5">
          <div className="name-wrapper text-[15px] font-[400] basis-1/2 relative">
            <label className="">
              Check in <span className="text-[#ff0000]">*</span>
            </label>
            <div
              onClick={() => setCheckinOpenDate(!openCheckinDate)}
              className="flex items-center justify-between border border-l pl-[20px] h-[56px] bg-white mt-[10px]"
            >
              <span className="text-gray-text ml-[-16px]">
                {checkinDateState}
              </span>
              <AiTwotoneCalendar className="text-gray-text text-[18px] mr-[20px]"></AiTwotoneCalendar>
            </div>
            {openCheckinDate && (
              <div className="absolute z-[1000] top-[80px] left-1/2 transform -translate-x-1/2  shadow-lg z-[1]">
                <Calendar
                  date={new Date()}
                  onChange={handleCheckinSelect}
                  minDate={new Date()}
                />
                <button
                  className="bg-golden flex items-center justify-center text-white font-bold w-full h-[50px] border-2 border-grey-200"
                  onClick={() => {
                    setCheckinOpenDate(false);
                  }}
                >
                  Done
                </button>
              </div>
            )}
          </div>
          <div className="name-wrapper text-[15px] font-[400] basis-1/2 relative">
            <label className="">
              Check out <span className="text-[#ff0000]">*</span>
            </label>
            <div
              onClick={() => setCheckoutOpenDate(!openCheckoutDate)}
              className="flex items-center justify-between border border-l pl-[20px] h-[56px] bg-white mt-[10px]"
            >
              <span className="text-gray-text ml-[-16px]">
                {checkoutDateState}
              </span>
              <AiTwotoneCalendar className="text-gray-text text-[18px] mr-[20px]"></AiTwotoneCalendar>
            </div>
            {openCheckoutDate && (
              <div className="absolute z-[1000] top-[80px] left-1/2 transform -translate-x-1/2  shadow-lg z-[1]">
                <Calendar
                  date={new Date()}
                  onChange={handleCheckoutSelect}
                  minDate={addDays(new Date(), 1)}
                />
                <button
                  className="bg-golden flex items-center justify-center text-white font-bold w-full h-[50px] border-2 border-grey-200"
                  onClick={() => {
                    setCheckoutOpenDate(false);
                  }}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>

        {/* Room type and Number of Rooms */}

        <div className="flex justify-center space-x-5 mt-[25px]">
          <div className="number-wrapper text-[15px] font-[400] basis-1/2 relative">
            <label className="">
              Room type <span className="text-[#ff0000]">*</span>
            </label>
            <div
              onClick={() => setOpenDropdown(!openDropdown)}
              className="flex items-center border  h-[56px] mt-[10px] bg-white"
            >
              <div className="ml-[10px] w-full">
                <span className="text-gray-text flex ">
                  <span className="flex items-center justify-between w-[100%]">
                    {typeState}
                    <MdOutlineArrowDropDown
                      className="ml-[5px] mr-[20px]"
                      size={30}
                    ></MdOutlineArrowDropDown>
                  </span>
                </span>
                {openDropdown && (
                  <div className="options cursor-pointer">
                    <div
                      className="optionItem"
                      onClick={() => setTypeState("Standard Room")}
                    >
                      <span className="optionText">Standard Room</span>
                    </div>
                    <div
                      className="optionItem"
                      onClick={() => setTypeState("Twin Room")}
                    >
                      <span className="optionText">Twin Room</span>
                    </div>
                    <div
                      className="optionItem"
                      onClick={() => setTypeState("Deluxe Room")}
                    >
                      <span className="optionText">Deluxe Room</span>
                    </div>
                    <div
                      className="optionItem"
                      onClick={() => setTypeState("Suite Room")}
                    >
                      <span className="optionText">Suite Room</span>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="number-wrapper text-[15px] font-[400] basis-1/2">
            <label className="">
              No. of Rooms<span className="text-[#ff0000]">*</span>
            </label>
            <input
              className="w-[100%] text-gray-text border border-[#dedede] px-[12px] py-[16px] mt-[10px]"
              id="roomnumber"
              name="roomnumber"
              placeholder="Choose 1-20"
              type="number"
            ></input>
          </div>
        </div>

        <div className="flex justify-center space-x-5 mt-[25px]">
          <div className="name-wrapper text-[15px] font-[400] basis-1/2 ">
            <label className="">
              Your Email <span className="text-[#ff0000]">*</span>
            </label>
            <input
              className="w-[100%] text-gray-text border border-[#dedede] px-[12px] py-[16px]  mt-[10px]"
              id="email"
              name="email"
              type="email"
            ></input>
          </div>

          <div className="name-wrapper text-[15px] font-[400] basis-1/2">
            <label className="">
              Your Phone <span className="text-[#ff0000]">*</span>
            </label>
            <input
              className="w-[100%] text-gray-text border border-[#dedede] px-[12px] py-[16px] mt-[10px]"
              id="phone"
              name="phone"
            ></input>
          </div>
        </div>

        <div className="flex justify-center space-x-5 mt-[25px]">
          <div className="name-wrapper text-[15px] font-[400] w-full">
            <label className="">
              Special Requirements <span className="text-[#ff0000]">*</span>
            </label>
            <input
              className="w-[100%] text-gray-text border border-[#dedede] px-[12px] py-[16px] mb-[25px] mt-[10px] h-[100px]"
              id="requirement"
              name="requirement"
            ></input>
          </div>
        </div>

        <div className="flex justify-center my-[20px]">
          <button
            id="booknow-btn"
            className="bg-golden w-[200px] h-[50px] text-white font-bold  mt-[30px] md:mt-[10px] mx-auto"
            type="submit"
          >
            <p className="">Send Enquiry</p>
          </button>
        </div>
      </form>
    </div>
  );
};
